import { Subscription } from 'rxjs';
import { Component } from '@angular/core';
import { DatePipe } from '@angular/common';
import { IonicPage, NavController, NavParams, ToastController, Loading, ModalController } from 'ionic-angular';
import { Store } from '@ngrx/store';
import { Observable } from '../../../node_modules/rxjs';
import { AppStore } from '../../store/AppStore';
import { LoginPage } from '../login/login';
import { ClearNotificationsAction } from '../../store/action/NotificationActions';
import { LogoutAction } from '../../store/action/UserActions';

import { UserService } from '../../services/UserService';
import { DocrenService } from '../../services/docren-service';

import _ from 'lodash';
import { saveAs } from 'file-saver';
import { FilePreviewPage } from './file-preview';

@IonicPage()
@Component({
  selector: 'page-docren',
  templateUrl: 'docren.html',
  providers: [DatePipe]
})

export class DocrenPage {

  public icons: string[];
  public filteredItems: Array<any> = [];
  public myFiles: Array<any> = [];
  public nodes: Array<any> = [];
  public searchInput: string = null;
  public shouldShowCancelSearch: boolean = false;
  public isLoading: boolean;
  public loader: Loading;

  public pages = [
    {
      title: 'Folder 01',
      sub: [
        {
          title: 'Folder 02', sub: [
            { title: 'File01', component: null },
            { title: 'File02', component: null },
            { title: 'File03', component: null }
          ]
        },
        { title: 'Folder 03', component: null },
        {
          title: 'Folder 04', sub: [
            { title: 'File04', component: null },
            { title: 'File05', component: null },
            {
              title: 'Folder 06', sub: [
                { title: 'File06', component: null },
                { title: 'File07', component: null },
                { title: 'File08', component: null }
              ]
            }
          ]
        }
      ]
    },
    {
      title: 'Folder 07',
      sub: [
        { title: 'Node 02.1', component: null },
        { title: 'Node 02.2', component: null },
        { title: 'Node 02.3', component: null }
      ]
    },

    {
      title: 'Folder 08',
      sub: [
        { title: 'Node 03.1', component: null },
        { title: 'Node 03.2', component: null },
        { title: 'Node 03.3', component: null }
      ]
    }
  ];

  private userSubscription: Subscription;
  private docrenSubscription: Subscription;

  private userId: number;
  private clienteId: number;
  private fileId: number;
  private isManager: boolean;
  private loggingOff: boolean;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private store: Store<AppStore>,
    private toastCtrl: ToastController,
    private modalCtrl: ModalController,
    private userService: UserService,
    private docrenService: DocrenService
  ) { this.loggingOff = false; }

  logoff() {
    this.presentToast('Acesso expirado. Efetue login novamente. (9)');
    localStorage.removeItem('expirationDate');
    this.store.dispatch(new LogoutAction());
    this.store.dispatch(new ClearNotificationsAction());
    this.navCtrl.setRoot(LoginPage);
  }

  ionViewDidLoad() {
    if (this.navParams.get('fileId'))
      this.fileId = this.navParams.get('fileId');
  }

  ionViewWillEnter() {
    this.isLoading = false;

    this.userSubscription = this.store.select('userState').subscribe(userState => {
      if (userState.expired == true && !this.loggingOff) {
        this.loggingOff = true;
        this.logoff();
      }
      if (userState.user != null) {
        this.userId = userState.user.id;
        this.clienteId = userState.user.clienteId;
        this.isManager = _.some(userState.user.roles, { "nome": "ROLE_GESTOR_DOCREN" });
        this.getFiles(this.clienteId, this.userId);
      }
    });
  }

  private getFiles(clientId: number, userId: number) {
    Observable.forkJoin(
      this.docrenService.listEplusFileByClienteId(clientId),
      this.userService.findMyTeams(userId),
      this.docrenService.listCategoriesByClienteId(clientId)
    ).subscribe(data => {
      this.nodes = this.docrenService.formatNodes((data[2] || []), false);

      this.myFiles = this.docrenService
        .getAvailableFilesByTeams((data[0] || []), (data[1] || []), this.isManager);

      this.filteredItems = this.myFiles;
      if (this.myFiles.some(item => item.id == this.fileId))
        this.previewFile(this.fileId);
    });
  }

  ionViewWillLeave() {
    if (this.userSubscription != null) this.userSubscription.unsubscribe();
    if (this.docrenSubscription != null) this.docrenSubscription.unsubscribe();
  }

  download(fileId) {
    try {
      const fileValue = this.myFiles.find(item => item.id == fileId);

      if (!fileValue) return;

      this.docrenService.download(this.userId, fileId).subscribe((data) => {
        var blob = new Blob([data], { type: data.type });
        saveAs(blob, fileValue.fileOriginal);
        this.presentToast("Download Concluído");
      });
    } catch (error) {
      this.presentToast("Download Inválido");
    }

  }

  previewFile(fileId) {
    const fileValue = this.myFiles.find(item => item.id == fileId);

    if (!fileValue) return;

    const modal = this.modalCtrl.create(FilePreviewPage, { file: fileValue }, { showBackdrop: true });
    modal.present();
  }

  downloadEvent(id) {
    this.download(id);
  }

  previewFileEvent(id) {
    this.previewFile(id);
  }

  search(e) {
    this.shouldShowCancelSearch = true;
    this.filteredItems = this.myFiles.filter(x => x.fileTitulo.indexOf(this.searchInput) >= 0);
  }

  cancelSearch(e) {
    this.searchInput = '';
    this.shouldShowCancelSearch = false;
    this.filteredItems = this.myFiles;
  }

  presentToast(message: string) {
    let toast = this.toastCtrl.create({
      message: message,
      duration: 3000,
      position: 'top'
    });
    toast.present();
  }
}



// WEBPACK FOOTER //
// ./src/pages/docren/docren.ts